import { render, staticRenderFns } from "./BrokerOrders.vue?vue&type=template&id=e94dcb1c&"
import script from "./BrokerOrders.vue?vue&type=script&lang=js&"
export * from "./BrokerOrders.vue?vue&type=script&lang=js&"
import style0 from "./BrokerOrders.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports